"use client"

import { Alert } from "src/components/common/Alert"
import { PrimaryButton } from "src/components/common/PrimaryButton"
import { BellRingIcon } from "src/components/icons"
import { newsletterSignupId } from "src/components/layout/newsletter/constants"
import { localizeText } from "src/localization/utils"
import { scrollToId } from "src/utilities/scroll"

export const SubscribeToNewsletter = () => {
  const T = localizeText(text)

  return (
    <Alert>
      <div className="flex flex-col gap-6">
        <div className="flex items-center gap-4">
          <BellRingIcon className="h-6 w-6 shrink-0" /> {T.getNotified}
        </div>

        <PrimaryButton size="small" color="primary" onClick={() => scrollToId(newsletterSignupId)}>
          {T.goToNewsletter}
        </PrimaryButton>
      </div>
    </Alert>
  )
}

const de = {
  getNotified: "Werde benachrichtigt, wenn die Box verfügbar ist.",
  goToNewsletter: "Zum Newsletter",
}

const en: typeof de = {
  getNotified: "Get notified when box is available.",
  goToNewsletter: "Subscribe to newsletter",
}

const text = { de, en }
